/*

? First, let's import the interface that will describe the shape of our sales support investment object.

*/

import StateInterface from "../state-interface";

export const sales_support_investment: StateInterface["sales_support_investment"] = {
	_id: "",
	status: "draft",
	investor: {
		user_id: "",
		business_profile_id: "",
		is_business_profile: false,
		name: "",
		email: "",
		phone: {
			country_code: "",
			phone_number: "",
		},
		bank_details: {
			account_holder_name: "",
			account_number: "",
			ifsc_code: "",
			bank_name: "",
			upi_id: "",
		},
		notes: "",
	},
	kyc_info: {
		rera_certificate: {
			rera_number: "",
			file_id: "",
			mime_type: "",
		},
		gst_certificate: {
			gst_number: "",
			file_id: "",
			mime_type: "",
		},
		pan: {
			pan_number: "",
			file_id: "",
			mime_type: "",
		},
		aadhaar: {
			aadhaar_number: "",
			file_id: "",
			mime_type: "",
		},
	},
	terms: {
		invested_amount: 0,
		currency: "INR",
		return_model: "fixed_percentage",
		promised_return_percentage: 0,
		promised_return_amount: 0,
		commission_share_percentage: 0,
		approx_tenure_months: 0,
		committed_at: new Date().toISOString(),
		maturity_date: new Date().toISOString(),
	},
	capital: {
		currency: "INR",
		total_received: 0,
		total_deployed: 0,
		total_returned: 0,
		balance_undeployed: 0,
	},
	allocations: [],
	transactions: [],
	created_by: {
		is_business_profile: false,
		user_id: "",
		business_profile_id: "",
	},
	internal_notes: "",
	test: false,
	created_at: new Date().toISOString(),
	updated_at: new Date().toISOString(),
	is_deleted: false,
	deleted_at: new Date().toISOString(),
};

export default sales_support_investment;
